<template>
	<div>
		<header class="page-title">
			<h2>Edit Content - {{data.name}}</h2>
			<div class="ml-auto">
				<a @click="saveContent" class="btn btn-md btn-success" v-if="!showExport"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>
		<div class="card" v-if="!showExport">
			<header class="card-header language-list">
				<nav>
					<ul class="tabs" v-if="languages">
						<li :class="index === selectedLanguage ? 'active' : ''" @click="setLanguage(index)" v-for="(lang, index) in languages">
							<a href="#">
								<img :alt="lang.title" :src="lang.flagIconUrl" :title="lang.title">
								{{ lang.title }}
							</a>
						</li>
					</ul>
				</nav>
			</header>
			<div class="card-body">
				<div class="form-group">
					<image-uploader
							:data-title="'Featured Image'"
							:data-path="'/staticpage/'"
							:data-post-url="'/uploadImage'"
							:data-model-id="id"
							:data-image="data.featuredImageUrl"
					></image-uploader>
				</div>
				<div class="form-group" v-for="(item, key) in fields">
					<label>{{ item.label }} (id: {{ item.id }})</label>
					<textarea :id="item.type + '_' + item.id" v-if="item.type === 'text'" v-model="translations[item.id][languages[selectedLanguage].locale].value"></textarea>
					<input :id="item.type + '_' + item.id" type="text" v-if="item.type === 'input'" v-model="translations[item.id][languages[selectedLanguage].locale].value">
					<div :id="item.type + '_' + item.id" class="form-group" v-if="item.type === 'editor'">
						<editor
								:api-key="tinyMCEApiKey"
								:init="tinyMCEConfig"
								v-model="translations[item.id][languages[selectedLanguage].locale].value"
						/>
					</div>
				</div>
			</div>
		</div>
		<div class="card" v-if="showExport">
			<div class="card-body">
				<div class="card-subtitle">
					To Export: Press Export button to show the exportable content,then CTRL+A & CTRL+C to copy all the content, then CTRL+V where you want to import
					To import: paste here the copied exportable content then press the import button
				</div>
				<div class="form-group">
					<textarea v-model="json"></textarea>
				</div>
			</div>
		</div>
		<a @click="exportContentToJson" class="btn btn-md btn-success" v-if="showExport"><i class="fas fa-sign-out-alt"></i> Export</a>
		<a @click="importContentFromJson" class="btn btn-md btn-success" v-if="showExport"><i class="fas fa-sign-in-alt"></i> Import</a>
		<a @click="showExportOrContent('export')" class="btn btn-md btn-primary" v-if="!showExport"><i class="fas fa-magic"></i> Export/Import</a>
		<a @click="showExportOrContent('content')" class="btn btn-md btn-primary" v-if="showExport"><i class="fas fa-undo"></i> Back to Content</a>
	</div>
</template>

<script>
	import modal from '../../Modal/DefaultModal.vue';
	import VueSelect from 'vue-select';
	import {eventBus} from '../../../app';

	export default {
		props: {
			data: {
				type: Object
			},
		},
		components: {
			modal,
			"vue-select": VueSelect,
		},
		data() {
			return {
				id: this.data.id,

				tinyMCEApiKey: this.$tinyMCEApiKey,
				tinyMCEConfig: this.$tinyMCEConfig,

				languages: this.data.languages,
				selectedLanguage: 0,
				translations: this.data.translations,

				fields: this.data.fields,

				showExport: false,

				json: '',
			}
		},
		created() {
			this.setLanguage(0);
		},
		mounted() {
			let vm = this;
			this.setLanguage(0);
			this.getFields();
			eventBus.$on('changeid', function (originalId, newId) {
				vm.translations[newId] = vm.copyWithoutReact(vm.translations[originalId]);
				Vue.delete(vm.translations, originalId);
			});
		},
		methods: {
			toArray: function (object) {
				return Object.keys(object).map(function (key) {
					return object[key];
				});
			},
			setLanguage: function (index) {
				let vm = this;
				this.selectedLanguage = index;

				//for texts
				if (typeof this.translations !== 'object' || this.translations.length === 0) {
					this.translations = {};
				}

				Object.keys(this.fields).forEach(key => {
					let item = this.fields[key];

					if (typeof vm.translations[item.id] === 'undefined' || vm.translations[item.id].length === 0) {
						vm.translations[item.id] = {};
						vm.translations[item.id].id = item.id;
					}
					if (typeof vm.translations[item.id][vm.languages[vm.selectedLanguage].locale] === 'undefined') {
						vm.translations[item.id][vm.languages[vm.selectedLanguage].locale] = {};
						vm.translations[item.id][vm.languages[vm.selectedLanguage].locale].value = '';
					}
				});
			},
			forceUpdate: function () {
				this.$forceUpdate();
			},
			saveContent: function () {
				let vm = this;
				axios.post('/api/' + vm.$selectedSite.slug + '/staticpage/' + vm.id + '/savecontent',
					{
						id: vm.id,
						translations: vm.translations
					},
				).then(function (response) {
					vm.$toastr.success('Content saved successfully.');
					location.reload();

				}).catch(function (e) {
					vm.$toastr.error('Content saving failed.', 'Error');
				});
			},
			getFields: function () {
				let vm = this;
				axios.get('/api/' + vm.$selectedSite.slug + '/staticpage/' + vm.id + '/getfields')
					.then(function (response) {
						vm.fields = response.data.fields;
						vm.$toastr.success('Fields refreshed successfully');
						vm.setLanguage(0);
					}).catch(function (e) {
					vm.$toastr.error('Fields refreshing failed.', 'Error');
				});
			},
			copyWithoutReact: function (data) {
				return JSON.parse(JSON.stringify(data));
			},
			showExportOrContent: function (showWhat) {
				if (showWhat === 'export') {
					this.showExport = true;
					this.exportContentToJson();
				}
				if (showWhat === 'content') {
					this.showExport = false;
				}
			},
			exportContentToJson: function () {
				let vm = this;
				axios.post('/api/' + vm.$selectedSite.slug + '/staticpage/' + vm.id + '/export',
					{
						id: vm.id,
					},
				).then(function (response) {
					vm.json = JSON.stringify(response.data, null, 2);
				}).catch(function (e) {
					vm.$toastr.error('Exporting failed.', 'Error');
				});
			},
			importContentFromJson: function () {
				let vm = this;
				axios.post('/api/' + vm.$selectedSite.slug + '/staticpage/' + vm.id + '/import',
					{
						id: vm.id,
						json: vm.json
					},
				).then(function (response) {
					vm.$toastr.success('Import successfully.');
					location.reload();
				}).catch(function (e) {
					vm.$toastr.error('Importing failed.', 'Error');
				});
			}
		}
	}
</script>
